import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import Text from '../../../../components/text/Text'
import {
    currencyFormat,
    formatToISO,
    parseStringDate,
} from '../../../../formatters'
import { TransactionsStyles } from './TransactionsStyles'
import { getHomeTransactions } from '../../../../services/amipos'
import SaleModalComponent, {
    ReverseModalState,
} from '../../../../components/modal/SaleModal'
import { useTokensContext } from '../../../../context/tokensContext'
import { TransactionResponse } from '../../../../services/commerce'
import { useLoadingContext } from '../../../../context/spinnerContext'
import { es } from 'date-fns/locale'

interface ResponseData {
    tip: string
    idTransaction: string
    typeTransaction: string
    amount: string
    creationDate: string
    client: string
    statusTx: string
    invoiced: string
    token: string
    description: string
    typeSale: string
    prefix: string
    typePayment: string
    authorizationCode: string
}

export function TransactionsComponent() {
    const [sales, setSales] = useState<TransactionResponse[]>([])
    const loadingContext = useLoadingContext()

    const [openModal, setOpenModal] = useState(false)
    const [selectedTransaction, setSelectedTransaction] =
        useState<TransactionResponse | null>(null)
    const [reverseStates, setReverseStates] = useState<{
        [key: string]: ReverseModalState
    }>({})
    const tokens = useTokensContext()

    const getTransactions = () => {
        getHomeTransactions()
            .then((response) => {
                setSales(
                    response.data.map((i: ResponseData) => ({
                        idTransaccion: i.idTransaction,
                        sTipoTransaccion: i.typeTransaction,
                        nMonto: i.amount,
                        dTransaccion: formatToISO(i.creationDate),
                        sNombreCliente: i.client,
                        sEstadoTx: i.statusTx,
                        sFacturada: i.invoiced,
                        sToken: i.token,
                        sTip: i.tip,
                        sTypeSale: i.typeSale,
                        idTransaction: i.idTransaction,
                        prefix: getPrefix(i.typeTransaction),
                        authorizationCode: i.authorizationCode,
                        typePayment: i.typePayment,
                    }))
                )
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                loadingContext?.onClose()
            })
    }

    useEffect(getTransactions, [])

    const variations: {
        [key: string]: { background: string; color: string }
    } = {
        TX: {
            background: '#BAE7FF',
            color: '#2196F3',
        },
        AN: {
            background: '#FFECCB',
            color: '#E2A03F',
        },
        BCI: {
            background: '#FFE1E2',
            color: '#E7515A',
        },
        GNT: {
            background: '#FFE1E2',
            color: '#E7515A',
        },
        OG: {
            background: '#DCCFF7',
            color: '#805DCA',
        },
        '.': {
            background: '#BAE7FF',
            color: '#2196F3',
        },
    }

    const getPrefix = (prefix: string) => {
        const keys = Object.keys(variations)
        if (keys.includes(prefix)) {
            return prefix
        } else return '.'
    }

    const handleOpenModal = (transaction: TransactionResponse) => {
        setSelectedTransaction(transaction)
        setOpenModal(true)
    }

    const handlerRefresh = () => {
        setOpenModal(false)
        loadingContext?.onOpen()
        getTransactions()
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const updateReverseState = (
        transactionId: string,
        newState: ReverseModalState
    ) => {
        getTransactions()
        selectedTransaction &&
            setSelectedTransaction({
                ...selectedTransaction,
                sEstadoTx: newState,
            })

        setReverseStates((prevStates) => ({
            ...prevStates,
            [transactionId]: newState,
        }))
    }

    return (
        <div style={TransactionsStyles.container}>
            <div style={TransactionsStyles.header}>
                <Text
                    fontSize={19}
                    color="#184287"
                    fontWeight={600}
                    label="Últimos movimientos"
                />
            </div>
            <div>
                {sales.map((i, key) => (
                    <div
                        key={key}
                        style={TransactionsStyles.itemContent}
                        onClick={() => handleOpenModal(i)}
                    >
                        <div style={TransactionsStyles.itemInfoContent}>
                            <div
                                style={{
                                    ...TransactionsStyles.itemIconContent,
                                    backgroundColor: variations[i.prefix]
                                        ? variations[i.prefix].background
                                        : '#BAE7FF',
                                }}
                            >
                                <Text
                                    label={i.typePayment || ''}
                                    fontSize={14}
                                    color={
                                        variations[i.prefix]
                                            ? variations[i.prefix].color
                                            : '#2196F3'
                                    }
                                    fontWeight={600}
                                />
                            </div>
                            <div style={TransactionsStyles.itemText}>
                                <Text
                                    label={i.sTypeSale}
                                    fontWeight={600}
                                    color="#184287"
                                    fontSize={14}
                                />
                                <Text
                                    label={(() => {
                                        const fecha = format(
                                            parseStringDate(i.dTransaccion),
                                            'dd MMM h:mmaaa',
                                            { locale: es }
                                        )

                                        const [dia, mes, hora] =
                                            fecha.split(' ')

                                        const mesCapitalizado =
                                            mes.charAt(0).toUpperCase() +
                                            mes.slice(1)

                                        return `${dia} ${mesCapitalizado} ${hora}`
                                    })()}
                                    fontWeight={400}
                                    color="#656565"
                                    fontSize={12}
                                />
                            </div>
                        </div>
                        <Text
                            fontSize={12}
                            fontWeight={400}
                            label={`${
                                Number(i.nMonto) >= 0 ? '+' : ''
                            }${currencyFormat(Number(i.nMonto))}`}
                            color={
                                (i.sToken?.includes('GETNET') ||
                                    i.sToken?.includes('BCI')) &&
                                i.sEstadoTx === 'ANULADA'
                                    ? 'red'
                                    : Number(i.nMonto) >= 0
                                    ? '#74BE00'
                                    : 'red'
                            }
                            style={{
                                textDecoration:
                                    (i.sToken?.includes('GETNET') ||
                                        i.sToken?.includes('BCI')) &&
                                    i.sEstadoTx === 'ANULADA'
                                        ? 'line-through'
                                        : 'none',
                            }}
                        />
                    </div>
                ))}
            </div>

            {selectedTransaction && (
                <SaleModalComponent
                    open={openModal}
                    handleClose={handleCloseModal}
                    sale={selectedTransaction}
                    tokens={tokens}
                    handlerRefresh={handlerRefresh}
                    reverseState={
                        reverseStates[selectedTransaction.idTransaccion] ||
                        ReverseModalState.Inicial
                    }
                    updateReverseState={(newState) =>
                        updateReverseState(
                            selectedTransaction.idTransaccion,
                            newState
                        )
                    }
                />
            )}
        </div>
    )
}
